
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/[articleCategory]/[article]",
      function () {
        return require("private-next-pages/help-centre/[articleCategory]/[article]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/[articleCategory]/[article]"])
      });
    }
  